export default function getResource(label, vars = []) {
    const resources = {
        share: 'Share',
        sharePost: 'Share Post',
        shareProfile: 'Share Profile',
        shareProduct: 'Share Product',
        shareCollection: 'Share Collection',
        copyLinkText: 'Copy the link and share it with friends:',
        copy: 'Copy',
        copied: 'Copied!',
        allProducts: 'All Products',
        featuredHeader: 'Featured',
        featured: 'Featured',
        products: 'Products',
        collections: 'Collections',
        posts: 'Posts',
        viewDetails: 'View Details',
        showMoreCollections: 'Show More Collections',
        items: 'items',
        addToBasket: 'Add to Basket',
        moreFrom: 'More from',
        viewAll: 'View all',
        shopWith: 'Shop with',
        goToStorefront: 'Go to Storefront',
        defaultDisplayName: 'Creator',
        seoPageTitle: `${vars[0]}'s Sephora Storefront | Sephora`,
        seoPageTitleProducts: `${vars[0]}'s Sephora Storefront - Products | Sephora`,
        seoPageTitleCollections: `${vars[0]}'s Sephora Storefront - Collections | Sephora`,
        seoMetaDescription: `Looking for ${vars[0]}'s favorite products at Sephora? Shop ${vars[0]}'s Sephora Storefront for a curated list of product recommendations and collections.`,
        postsOf: `${vars[0]}'s Posts`,
        commissionableLinks: 'Contains Commissionable Links'
    };

    return resources[label];
}
